import React, { useState } from 'react';
import Character from './Character'; // Import the Character component
import ISwipe from './ISwipe'; // Import the ISwipe component
import BackgroundVideos from './BackgroundVideos'; // Import the new BackgroundVideos component
import './CharacterScreen.css';

const CharacterScreen = ({ state, onVideoEnd, handleStyleChange, handleChooseCharacter }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handleVideoLoaded = () => {
    setIsVideoLoaded(true);
  };

  return (
    <div id="app-window" className="container">
      <BackgroundVideos
        characterStyle={state.characterStyle}
        onVideoEnd={onVideoEnd}
        onVideoLoaded={handleVideoLoaded}
      />
      <div id="flex1">
        {/* Maintain consistency with main screen layout */}
      </div>
      <div id="flex2">
        <Character 
          isLowContrast={state.lowContrast} 
          isReducedMotion={state.reducedMotion} 
          characterStyle={state.characterStyle} // Pass character style as prop
          lowContrast={state.lowContrast}
          isInfo={state.isInfo}
          onChooseCharacter={handleChooseCharacter}
          isSelect={true} // Indicate that CharacterScreen is active
          isVideoLoaded={isVideoLoaded} // Pass video loaded state
        />
        {state.isInfo && (<ISwipe/>)}
      </div>
      <div id="flex3">
        {/* Empty flex3 to maintain layout */}
      </div>
    </div>
  );
};

export default CharacterScreen;
